import InternalRouter from 'navigation/pages/InternalRouter'
import MainPage from 'navigation/pages/MainPage'
import './Brand.scss'

type BrandType = {}

class Brand extends MainPage<BrandType> {
  constructor (...args: ConstructorParameters<typeof InternalRouter>) {
    super(...args)
    this.bindRefs()
  }

  initialized (): void {
    super.initialized()
  }
}

Brand.pageName = 'brand'

export default Brand
